// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import { getTwigs, getTwigChart, updateTwig, getAlerts, 
    saveAlert, updateAlert, deleteAlert, getUserPreferences, 
    saveUserPreferences, getSubscription, initializeStripe, 
    createStripeSubscription, validateCoupon, getSubscriptionDetails, 
    getCustomerCard} from './Api';
import { convertToISO } from '../utils/Utility';
import { dispatch } from 'd3-dispatch';
import { navEnable, showLoader, INITIALIZE_STRIPE } from './actions';

var _ = require('lodash');

export const GET_TWIGS = 'GET_TWIGS';
export const UPDATE_CHART = 'UPDATE_CHART';
export const CHANGE_DISPLAYOPTION = 'CHANGE_DISPLAYOPTION';
export const CHANGE_DEPTHOPTION = 'CHANGE_DEPTHOPTION';
export const CHANGE_TWIG = 'CHANGE_TWIG';
export const UPDATE_FROMDATE = 'UPDATE_FROMDATE';
export const UPDATE_TODATE = 'UPDATE_TODATE';
export const UPDATE_DATE_RANGE = 'UPDATE_DATE_RANGE';
export const CHANGE_RESOULTION = 'CHANGE_RESOULTION';
export const UPDATE_SELECTEDTWIG = 'UPDATE_SELECTEDTWIG';
export const SHOW_TRENDLINE = 'SHOW_TRENDLINE';
export const SHOW_RAWGRAPH = 'SHOW_RAWGRAPH';
export const CHANGE_TREND_AVERAGE = 'CHANGE_TREND_AVERAGE';
export const TOGGLE_UPPERLIMIT = 'TOGGLE_UPPERLIMIT';
export const TOGGLE_LOWERLIMIT = 'TOGGLE_LOWERLIMIT';
export const GET_ALERTS = 'GET_ALERTS';
export const RESET_CHART = 'RESET_CHART';
export const CLEAR_TWIGS = 'CLEAR_TWIGS';
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const SAVE_USER_PREFERENCES = 'SAVE_USER_PREFERENCES';
export const TOGGLE_ZOOM = "TOGGLE_ZOOM";
export const GET_STRIPEPLANS = "GET_STRIPEPLANS";
export const ADD_SUBSCRPTION = "ADD_SUBSCRPTION";
export const CONFIRM_SUBSCRIPTION = "CONFIRM_SUBSCRIPTION";
export const VALIDATE_COUPON = "VALIDATE_COUPON";
export const SHOW_CHART_VIEW = "SHOW_CHART_VIEW"
export const HANDLE_PAYMENT_INFO_SUBMIT = "HANDLE_PAYMENT_INFO_SUBMIT";
export const INIT_PAYMENT_INFO = "INIT_PAYMENT_INFO";
export const REMEMBER_ME = "REMEMBER_ME";
export const REBIND_COUPON_DATA = 'REBIND_COUPON_DATA';

export function loadTwigs(loadCharts, siteName, selectedTwigIndex) {
    return function (dispatch) {
        getTwigs(siteName)
            .then(response => {
                dispatch(storeTwigs(response, selectedTwigIndex))
                if (loadCharts && response.data[selectedTwigIndex].details) {
                    let twigId = response.data[selectedTwigIndex].twigId;
                    let fromDate = new Date();
                    fromDate.setDate(fromDate.getDate() - 14);
                    let toDate = new Date();
                    dispatch(loadChartData(twigId, fromDate.toISOString(), toDate.toISOString(), '', selectedTwigIndex));
                }
                else
                    dispatch(showLoader(false));
            })
            .catch(error => {
                dispatch(storeTwigs([], selectedTwigIndex));
                dispatch(showLoader(false));
            });
    };
}

export function getPageLoadData(twig, showPlansView, twigIndex) {
    return (dispatch => {
        initializeStripe().then(response => {
            dispatch({
                type: INITIALIZE_STRIPE,
                result: response
            });
            getTwigs('').then(twigs => {
                dispatch(storeTwigs(twigs, 0));
                let displayOptions = {};
                let stem;
                let isStemSubscribed = false;
                let selectedTwigIndex;
                let subscriptionSelected;
                let twigToSubscribe;
                getUserPreferences().then(response => {
                    if(twig && twig.twigId){
                        stem = twig.twigId;
                    }
                    else if(response && response.data && response.data.preference && response.data.preference.stem) {
                        stem = response.data.preference.stem
                    }
                    else{
                        stem = (twigs && twigs.data && twigs.data.length && twigs.data[0]) ? twigs.data[0].twigId: null;
                    }
                    if(sessionStorage.getItem('twigToSubscribe')){
                        twigToSubscribe = JSON.parse(sessionStorage.getItem('twigToSubscribe'));
                        if(twigToSubscribe  && twigToSubscribe.twigId){
                            stem = twigToSubscribe.twigId;
                            selectedTwigIndex = twigToSubscribe.twigIndex ? twigToSubscribe.twigIndex : '';
                            showPlansView = twigToSubscribe.showPlans ? true: false;
                            subscriptionSelected = twigToSubscribe.subscriptionSelected;
                        }
                        sessionStorage.removeItem('twigToSubscribe');
                    }
                    getSubscription(stem, showPlansView).then(data => {
                        if(data){
                            if(data.plans) {
                                if(twigIndex !== null && twigIndex !== undefined){
                                    dispatch(updateSelectedTwig(twigIndex));
                                }
                                else if(selectedTwigIndex){
                                    dispatch(updateSelectedTwig(selectedTwigIndex));
                                }
                                else {
                                    dispatch(updateSelectedTwig(
                                         (_.findIndex(twigs.data, twig=> twig.twigId === stem))
                                    ));
                                }
                                if(subscriptionSelected) {
                                    _.remove(data.plans.data, plan => {
                                       return plan.id === subscriptionSelected.details.subscription.plan.id;
                                    });
                                }
                                dispatch({
                                    type: GET_STRIPEPLANS,
                                    result: {
                                        success : data.success,
                                        stripePlans: data.plans,
                                        showStripePlans: data.success
                                    }
                                });
                                dispatch(showLoader(false));
                            }
                            else {
                                if (response && response.data && response.data.preference &&
                                    Object.keys(response.data.preference).length > 0) {
                                    if(twigToSubscribe && twigToSubscribe.twigId) {
                                        stem = twigToSubscribe.twigId;
                                    }
                                    else if(twig && twig.twigId && (twig.twigId !== response.data.preference.stem)){
                                        stem = twig.twigId;
                                        response.data.preference = Object.assign({}, response.data.preference, {selectedTwig: twig, stem});
                                    }
                                    else {
                                        stem = response.data.preference.stem;
                                    }
                                    let _selectedTwigIndex ;
                                    let _selectedTwig = _.find(twigs.data, (twig, index)=> {
                                        _selectedTwigIndex = index
                                        return twig.twigId === stem;
                                    });
                                    dispatch(updateSelectedTwig(_selectedTwigIndex));
                                    getTwigChart(stem, 
                                        convertToISO(response.data.preference.fromDate),convertToISO(response.data.preference.toDate), '')
                                        .then((dataPref) => {
                                            dispatch({
                                                type: GET_USER_PREFERENCES,
                                                result: {
                                                    UserPref: response.data,
                                                    chartData: dataPref ? dataPref.data : null,
                                                    subscription: data
                                                }
                                            });
                                            dispatch(showLoader(false));
                                    })
                                    .catch(error => {

                                    }); 
                                } else {
                                    let fromDate = new Date();
                                    fromDate.setDate(fromDate.getDate() - 14);
                                    let toDate = new Date();
                                    dispatch(updateSelectedTwig(0));
                                    dispatch(loadChartData(twigs.data[0].twigId, fromDate.toISOString(), toDate.toISOString(), '', 0));
                                }
                                dispatch(navEnable(false));
                                dispatch({
                                    type: SHOW_CHART_VIEW,
                                    result: {
                                        showSubscriptionForm : false,
                                        showStripePlans: false
                                    }
                                });
                            }
                        }
                    });
                })
                .catch(error => {

                });
            })
            .catch(error => {

            });
        });
    });
}

export function createSubscription(payload) {
    return function (dispatch) {
        createStripeSubscription(payload.paymentInformation).then((response)=> {
            dispatch(showChartView(payload));
        });
    }
}

let pageNumber = 1;
export function loadChartData(twigId, fromDate, toDate, pageNo, twigIndex) {
    return function (dispatch) {
        getSubscription(twigId).then(data => {
            if(data){
                if(data.plans) {
                    if(twigIndex !== null && twigIndex !== undefined){
                        dispatch(updateSelectedTwig(twigIndex));
                    }
                    dispatch({
                        type: GET_STRIPEPLANS,
                        result: {
                            success : data.success,
                            stripePlans: data.plans,
                            showStripePlans: data.success
                        }
                    });
                    dispatch(addSubscription(false));
                    dispatch(showLoader(false));
                }
                else {
                    getTwigChart(twigId, fromDate, toDate, '').then(response => {
                        // console.log('response::', response)
                        pageNumber = pageNumber + 1;
                        // if (!_.isEmpty(response.data)) {
                        //   dispatch(loadChartData(twigId, fromDate, toDate, pageNumber));
                        // }else{
                        //   alert('done ho')
                        // }
                        setTimeout(function () {
                            dispatch(updateChart(response))
                        }, 0);
                        dispatch({
                            type: UPDATE_CHART,
                            result: 'loading',
                        });
                        dispatch(navEnable(false));
                        dispatch({
                            type: SHOW_CHART_VIEW,
                            result: {
                                showSubscriptionForm : false,
                                showStripePlans: false
                            }
                        });
                        dispatch(showLoader(false));

                    }).catch(error => {
                        dispatch({
                            type: UPDATE_CHART,
                            result: 'loading',
                        });
                        // console.log('error::', error)
                    });
                }
            }
        })
        .catch(error => {
            dispatch(showLoader(false));
            // console.log('error::', error)
        });
    }
}

export function updateTwigApi(twigId, twigObj, siteName, selectedTwigIndex) {
    return function (dispatch) {
        updateTwig(twigId, twigObj).then(response => {
            // console.log('updateTwig::', response)
            dispatch(loadTwigs(false, siteName, selectedTwigIndex))
        }).catch(error => {
            // console.log('error::', error)
        });
    };
}

export function getAlertsApi(twigId) {
    return function (dispatch) {
        getAlerts(twigId).then(response => {
            // console.log('getAlerts::', response)
            dispatch({
                type: GET_ALERTS,
                result: response.data,
            })
        }).catch(error => {
            // console.log('error::', error)
        });
    };
}

export function addAlertAction(alertData, twigId) {
    return function (dispatch) {
        saveAlert(alertData).then(response => {
            // console.log('saveAlert::', response)
            dispatch(getAlertsApi(twigId));
        }).catch(error => {
            // console.log('error::', error)
        });
    };
}

export function updateAlertAction(alertId, alertData, twigId) {
    return function (dispatch) {
        updateAlert(alertId, alertData).then(response => {
            // console.log('updateAlert::', response)
            dispatch(getAlertsApi(twigId));
        }).catch(error => {
            // console.log('error::', error)
        });
    };
}

export function deleteAlertAction(alertId, twigId) {
    return function (dispatch) {
        deleteAlert(alertId).then(response => {
            // console.log('updateAlert::', response)
            dispatch(getAlertsApi(twigId));
        }).catch(error => {
            // console.log('error::', error)
        });
    };
}

export function getUserPreferencesAction() {
    return function (dispatch) {
        getUserPreferences().then(response => {
            if (response && response.data) {
                getTwigChart(response.data.preference.stem, response.data.preference.fromDate,
                    response.data.preference.toDate).then((dataPref) => {
                        dispatch({
                            type: GET_USER_PREFERENCES,
                            result: { UserPref: response.data, chartData: dataPref ? dataPref.data : null }
                        });
                    });
            }
            // console.log('getUserPreferences::', response);

        }).catch(error => {
            // console.log('getUserPreferenceserror::', error)
        });
    };
}

export function saveUserPreferencesAction(saveObj) {
    return function (dispatch) {
        saveUserPreferences(saveObj).then(response => {
            // console.log('getUserPreferences::', response);
            dispatch({
                type: SAVE_USER_PREFERENCES,
                result: response.data
            });
        }).catch(error => {
            // console.log('getUserPreferenceserror::', error)
        });
    };
}

export function updateSelectedTwig(index) {
    return {
        type: UPDATE_SELECTEDTWIG,
        index: index,
    };
}

export function updateFromDate(date) {
    return {
        type: UPDATE_FROMDATE,
        result: date,
    };
}

export function updateToDate(date) {
    return {
        type: UPDATE_TODATE,
        result: date,
    };
}

export function updateChart(response) {
    return {
        type: UPDATE_CHART,
        result: response.data,
    };
}

export function updateDateRange(range) {
    return {
        type: UPDATE_DATE_RANGE,
        result: range,
    };
}

export function storeTwigs(response, index) {
    return {
        type: GET_TWIGS,
        result: response.data,
        selectedIndex: index
    };
}

export function changeDisplayOption(payload) {
    return {
        type: CHANGE_DISPLAYOPTION,
        result: payload,
    };
}

export function showUpperLimit(payload) {
    return {
        type: TOGGLE_UPPERLIMIT,
        result: payload,
    };
}
export function showLowerLimit(payload) {
    return {
        type: TOGGLE_LOWERLIMIT,
        result: payload,
    };
}

export function changeDepthOption(payload) {
    return {
        type: CHANGE_DEPTHOPTION,
        result: payload,
    };
}

export function changeTwig(index) {
    return {
        type: CHANGE_TWIG,
        result: index
    }
}

export function changeResolution(resolution) {
    return {
        type: CHANGE_RESOULTION,
        result: resolution
    }
}

export function showTrendLine(payload) {
    return {
        type: SHOW_TRENDLINE,
        result: payload
    }
}

export function showRawGraph(payload) {
    return {
        type: SHOW_RAWGRAPH,
        result: payload
    }
}

export function changeTrendAverage(value) {
    return {
        type: CHANGE_TREND_AVERAGE,
        result: value
    }
}

export function clearTwigsList() {
    return {
        type: CLEAR_TWIGS,
        result: {}
    }
}

export function changeZoomOption(value) {
    return {
        type: TOGGLE_ZOOM,
        result: value
    }
}

export function addSubscription (payload) {
    return (dispatch => {
        getCustomerCard()
        .then(savedCard => {
            if(savedCard && savedCard.card && savedCard.stripeCustomerId){
                if(payload){
                    payload.rememberMe = true;
                    payload.savedCard = savedCard;
                }
            }
            dispatch({
                type: ADD_SUBSCRPTION,
                result: payload
            });
        }).catch(error => {
            dispatch({
                type: ADD_SUBSCRPTION,
                result: payload
            });
        });
    });

}

export function showChartView (payload) {
    return (dispatch => {
        dispatch(getPageLoadData(payload.selectedTwig));
    });
}

export function validateCouponCode(coupon) {
    return function (dispatch) {
        if(coupon){
            validateCoupon(coupon).then(response => {
                dispatch({
                    type: VALIDATE_COUPON,
                    result: response
                });
                if(response && response.coupon && response.coupon.percent_off == 100){
                    let payload = {
                        showError : false
                    };
                    dispatch({
                        type: HANDLE_PAYMENT_INFO_SUBMIT,
                        result: payload
                    });
                }
                dispatch(showLoader(false));                
            }).catch(error => {
                // console.log('getUserPreferenceserror::', error)
            });
        }   
        else {
            dispatch({
                type: VALIDATE_COUPON,
                result: null
            });
            dispatch(showLoader(false));
            
        }
    };
}

export function handlePaymentInfoSubmission (payload){
    return (dispatch => {
        dispatch({
            type: HANDLE_PAYMENT_INFO_SUBMIT,
            result: payload
        });
    });
}

export function initializePaymentInformation (payload) {
    return (dispatch => {
        dispatch({
            type: INIT_PAYMENT_INFO,
            result: payload
        });
    });
}

export function rememberCardData (value) {
    return (dispatch => {
        dispatch({
            type : REMEMBER_ME,
            result: value
        });
    });
}

export function rebindCouponData(value) {
    return (dispatch => {
        dispatch({
            type : REBIND_COUPON_DATA,
            result: value
        });
    });
}


// WEBPACK FOOTER //
// ./src/js/actions/locationView.js